import { DialogCommonComponent } from '../dialog-common/dialog-common.component';
import { DialogRef } from '@my-backoffice/app/shared/components/modal/shared/classes/dialog.ref';
import { IDialogDelete } from '@my-backoffice/app/shared/components/modal/shared/components/dialog-delete/shared/interfaces/dialog-delete.interface';
import { DIALOG_DATA } from '@my-backoffice/app/shared/components/modal/shared/tokens/dialog.token';
import { QimaButtonService } from '@my-backoffice/app/shared/services/exported-services/qima-button/qima-button.service';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { QimaButtonModule } from '@qima/ngx-qima';

@Component({
  selector: 'app-dialog-delete',
  standalone: true,
  templateUrl: './dialog-delete.component.html',
  styleUrls: ['./dialog-delete.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DialogCommonComponent, QimaButtonModule, TranslateModule],
})
export class DialogDeleteComponent {
  public constructor(
    @Inject(DialogRef) private readonly _dialogRef: DialogRef<boolean>,
    @Inject(DIALOG_DATA) public readonly dialogData: IDialogDelete,
    public readonly qimaButton: QimaButtonService
  ) {}

  public close(): void {
    this._dialogRef.close(false);
  }

  public delete(): void {
    this._dialogRef.close(true);
  }
}
